import available from '../assets/translations/_.json';

export const availableLocales = available;

export const getDefaultLocale = () => availableLocales.find((locale) => locale.isDefault);

export const getLocale = (localeString) => {
    localeString = localeString || navigator.language || (navigator.languages ? navigator.languages[0] : undefined) || navigator.userLanguage;

    return availableLocales.find((locale) => locale.id === localeString) || getDefaultLocale();
};

export const translations = availableLocales.reduce((obj, locale) => ({
    ...obj,
    [locale.language]: require(`../assets/translations/${locale.language}.json`)
}), {});



// WEBPACK FOOTER //
// ./src/shared/translations.js